/**
 * @generated SignedSource<<b6ff75329b6e0670ad94bba981e23e46>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfiguratorTemplateInput = {
  customToken?: string | null;
  modelID?: number | null;
  productID?: string | null;
  templateID?: number | null;
};
export type presetConfigurationsQueriesIFrameUrlQuery$variables = {
  input: ConfiguratorTemplateInput;
};
export type presetConfigurationsQueriesIFrameUrlQuery$data = {
  readonly preSetPreviewUrl: string | null;
};
export type presetConfigurationsQueriesIFrameUrlQuery = {
  response: presetConfigurationsQueriesIFrameUrlQuery$data;
  variables: presetConfigurationsQueriesIFrameUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "preSetPreviewUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesIFrameUrlQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesIFrameUrlQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d24e208bc387db919d651ee73b091977",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesIFrameUrlQuery",
    "operationKind": "query",
    "text": "query presetConfigurationsQueriesIFrameUrlQuery(\n  $input: ConfiguratorTemplateInput!\n) {\n  preSetPreviewUrl(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "245ca44fb026897957732aeea5859812";

export default node;
